
export interface States {
  status?: string[];
}

export const STATUS_OKAY: string = "Disponible";

export const STATUS_DISCONNECTED: string = "No Disponible";
